// This allows us to define a publish schedule in advance and have these promos show/hide.
// The schedule is based on the current date and time. EX: unpublish_at: "2025-03-19T16:42:00" // please use this example set the time if needed

// For Cypress tests, use the test config to avoid dependency on real promotion schedules
import testConfig from './promoDrawsScheduleConfig.test.js';

let promoDrawsScheduleConfig = {
  // Promo Draws
  // "C362B105-A0B8-4F1E-B8DB-BF3FC3CAA2D5": {
  //   key: "examplePromo1",
  //   publish_at: "2024-03-10T11:30:00",
  //   unpublish_at: "2025-07-20T20:00:00",
  //   draw_end: "2025-03-20T20:05:00"
  // },
  // "EA2917A2-2D69-4E51-9E9E-A532CADCF887": {
  //   key: "examplePromo2",
  //   publish_at: "2024-03-24T11:30:00",
  //   unpublish_at: "2025-04-16T20:00:00",
  //   draw_end: "2025-04-11T22:05:00"
  // },
  // "D1C1B0B0-8E66-4E59-BD6A-92DB1196B25D": {
  //   key: "1DayTestForWebsite",
  //   publish_at: "2025-04-01T08:00:00",
  //   unpublish_at: "2025-06-02T18:00:00",
  //   draw_end: "2025-06-02T00:00:00-04:00" // TODO: Double check timezone on all these config dates
  // },
  // "1E0D1EA7-46BE-45D3-B99E-DDA84BED2DFE": {
  // "3BD44206-2BD6-44E1-8845-01C7A839ADF6": {
  //   key: "multiMillionaireMaker2025",
  //   drawType: "poker",
  //   publish_at: "2025-04-01T08:00:00",
  //   unpublish_at: "2025-06-02T18:00:00",
  //   earning_start: "2025-04-01T08:00:00", // Use the Eastern time that we need, but dont add the -04:00
  //   earning_end: "2025-06-01T23:59:59", // Use the Eastern time that we need, but dont add the -04:00
  //   draw_end: "2025-06-02T00:00:00" // Use the Eastern time that we need, but dont add the -04:00
  // },
  "521": {
    key: "hockeyNightAtPlayground2025",
    drawType: "egd",
    publish_at: "2026-02-01T09:00:00",
    earning_start: "2026-02-01T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2026-03-01T19:30:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2026-03-01T20:30:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2026-03-01T21:00:00"
  },
  "534": {
    key: "hockeyNightAtPlayground2025",
    drawType: "egd",
    publish_at: "2026-03-01T21:00:00",
    earning_start: "2026-03-01T21:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2026-04-01T19:30:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2026-04-01T20:30:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2026-04-01T21:00:00"
  },
  "8B5BFDD4-8BAE-4C7D-9D65-9759E341D8A5": {
    key: "multiMillionaireMakerSeptember2025",
    drawType: "poker",
    publish_at: "2025-09-04T13:00:00",
    earning_start: "2025-09-08T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2025-09-28T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2025-09-28T19:00:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2025-09-28T19:00:00"
  },
  // Triple Barrel Cash Blast February 2026 - Part 2 (Feb 2-15)
  "TRIPLE-BARREL-BLAST-FEBRUARY-2026-PT-2": {
    key: "tripleBarrelCashBlastFebruary2026",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "0F676B91-3AC1-4192-8236-1A6889BA05F6",
        labelKey: "silver"
      },
      {
        promotionId: "F0E98862-2D0B-44AF-AF71-4E32A2C1A5AB",
        labelKey: "gold"
      },
      {
        promotionId: "69074CE9-D410-44F2-9484-70C0A716A6AE",
        labelKey: "diamond"
      }
    ],
    publish_at: "2026-02-01T20:00:00",
    earning_start: "2026-02-02T08:00:00",
    earning_end: "2026-02-15T08:00:00",
    draw_end: "2026-02-15T22:00:00",
    unpublish_at: "2026-02-16T01:00:00"
  },
  // Triple Barrel Cash Blast February 2026 - Part 3 (Feb 16 - Mar 1)
  "TRIPLE-BARREL-BLAST-FEBRUARY-2026-PT-3": {
    key: "tripleBarrelCashBlastFebruary2026",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "11163EC3-E51C-4DAE-B8A0-D8F224BF22F1",
        labelKey: "silver"
      },
      {
        promotionId: "06D42FD6-8D26-40E4-8CE9-2D897C20AE0D",
        labelKey: "gold"
      },
      {
        promotionId: "EA75E5E4-C2DF-46CC-A79B-D362246AAA1C",
        labelKey: "diamond"
      }
    ],
    publish_at: "2026-02-16T01:00:00",
    earning_start: "2026-02-16T08:00:00",
    earning_end: "2026-03-01T08:00:00",
    draw_end: "2026-03-01T22:00:00",
    unpublish_at: "2026-03-02T01:00:00"
  },
  // Triple Barrel Cash Blast March 2026 (grouped multi-draw, silver/gold/diamond)
  "TRIPLE-BARREL-BLAST-MARCH-2026": {
    key: "tripleBarrelCashBlastMarch2026",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "2843BF56-2823-4CF6-BBE8-03288562FD25",
        labelKey: "silver"
      },
      {
        promotionId: "530D5ED4-BB10-4FFA-A45A-9B273F076118",
        labelKey: "gold"
      },
      {
        promotionId: "BC00FC2E-FD80-4566-A81B-537FE65CDC67",
        labelKey: "diamond"
      }
    ],
    publish_at: "2026-03-02T00:10:00",
    earning_start: "2026-03-03T08:00:00",
    earning_end: "2026-03-22T21:55:00",
    draw_end: "2026-03-22T23:59:59",
    unpublish_at: "2026-03-23T01:00:00"
  },
  // Club Elite Saturday Draws - 2604 Week 3 (Apr 12-19)
  "CLUB-ELITE-WEEK-3-2026-04": {
    key: "clubElite",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2026-04-11T18:00:00",
    earning_start:  "2026-04-12T00:00:00", // Sunday 12:00 AM
    earning_end:    "2026-04-18T15:59:59", // Saturday 3:59 PM
    draw_end:       "2026-04-18T17:00:00",
    unpublish_at:   "2026-04-18T18:00:00",
    subDraws: [
      { promotionId: "547" },
      { promotionId: "552" }
    ]
  },
  // Club Elite Saturday Draws - 2604 Week 4 (Apr 19-26)
  "CLUB-ELITE-WEEK-4-2026-04": {
    key: "clubElite",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2026-04-18T18:00:00",
    earning_start:  "2026-04-19T00:00:00", // Sunday 12:00 AM
    earning_end:    "2026-04-25T15:59:59", // Saturday 3:59 PM
    draw_end:       "2026-04-25T17:00:00",
    unpublish_at:   "2026-04-25T18:00:00",
    subDraws: [
      { promotionId: "548" },
      { promotionId: "553" }
    ]
  },
  // Club Elite Saturday Draws - 2604 Week 5 (Apr 26 - May 3)
  "CLUB-ELITE-WEEK-5-2026-04": {
    key: "clubElite",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2026-04-25T18:00:00",
    earning_start:  "2026-04-26T00:00:00", // Sunday 12:00 AM
    earning_end:    "2026-05-02T15:59:59", // Saturday 3:59 PM
    draw_end:       "2026-05-02T17:00:00",
    unpublish_at:   "2026-05-02T18:00:00",
    subDraws: [
      { promotionId: "549" },
      { promotionId: "554" }
    ]
  },
  // Spin & Spoil Mom 2026 (Apr 6 - May 10)
  "555": {
    key: "spinAndSpoilMom2026",
    drawType: "egd",
    publish_at: "2026-04-05T18:00:00",
    earning_start: "2026-04-06T00:00:00", // April 6 12:00 AM
    earning_end: "2026-05-10T18:55:00", // May 10 6:55 PM
    draw_end: "2026-05-10T20:00:00", // May 10 8:00 PM
    unpublish_at: "2026-05-10T21:00:00"
  }
};

// In Cypress test environment, use test config with fixed dates.
// `window.Cypress` keeps this reliable even when REACT_APP_* env vars are not
// injected into an already-running dev server.
const isCypressRuntime = typeof window !== 'undefined' && Boolean(window.Cypress);
if (process.env.REACT_APP_CYPRESS_TEST === 'true' || isCypressRuntime) {
  promoDrawsScheduleConfig = testConfig;
}

export default promoDrawsScheduleConfig;
